module.exports = __webpack_public_path__ + "img/preloader-export.9b60fe62.svg";